import { useContainerQuery } from './use-container-query';
import { getMatchingBreakpoint } from '../../breakpoints';
export function useContainerBreakpoints(triggers) {
    var triggersDep = triggers === null || triggers === void 0 ? void 0 : triggers.join();
    return useContainerQuery(function (rect) { return getMatchingBreakpoint(rect.width, triggers); }, [triggersDep]);
}
